import { render, staticRenderFns } from "./DoctorUpdates.vue?vue&type=template&id=e6071c78&scoped=true"
import script from "./DoctorUpdates.vue?vue&type=script&lang=js"
export * from "./DoctorUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6071c78",
  null
  
)

export default component.exports